import ProductService from '@/services/ProductService.js'

export const state = {
  units: [],
  unit: {}
}

export const mutations = {
  ADD_UNIT(state, unit) {
    state.units.push(unit)
  },
  DELETE_UNIT(state, unit) {
    state.units = state.units.filter(t => t.id != unit.id)
  },
  SET_UNITS(state, units) {
    state.units = units
  },
  SET_UNIT(state, unit) {
    state.unit = unit
  },
  EDIT_UNIT(state, unit) {
    state.unit = unit
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createUnit({ commit, dispatch }, unit) {
    return ProductService.postUnit(unit)
      .then(response => {
        commit('ADD_UNIT', unit)
        const notification = {
          type: 'success',
          message: 'Your new unit has been opened!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem opening new unit: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchUnits({ commit, dispatch }) {
    ProductService.getUnits()
      .then(response => {
        commit('SET_UNITS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching units: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  searchUnits({ commit, dispatch }, searchTerm) {
    ProductService.searchUnits(searchTerm)
      .then(response => {
        commit('SET_UNITS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching units: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchUnit({ commit, getters }, id) {
    var unit = getters.getUnitById(id)

    if (unit) {
      commit('SET_UNIT', unit)
      return unit
    } else {
      return ProductService.getUnit(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_UNIT', response.data[0])
          if (response.data && response.data.length > 0)
            return response.data[0]
        })
    }
  },
  async removeUnit({ commit }, unit) {
    await ProductService.deleteUnit(unit)
    commit('DELETE_UNIT', unit)
  },
  editUnit({ commit }, unit) {
    ProductService.updateUnit(unit)
    commit('EDIT_UNIT', unit)
  },
  getUnitInventoryStock({ dispatch }) {
    return new Promise((resolve, reject) => {
      ProductService.getUnitInventoryStock()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching unit inventories: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        reject(error)
      })
    })
  },
  markInventoryActivity({ dispatch }, body) {
    return new Promise((resolve, reject) => {
      ProductService.markInventoryActivity(body)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem marking inventory activity: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        reject(error)
      })
    })
  }
}

export const getters = {
  getUnitById: state => id => {
    return state.units.find(unit => unit.id === id)
  }
}
